import CloseIcon from '@common/components/icons/CloseIcon';
import * as styles from './index.module.css';
import { getFilterTypeLabel, getFilterValueLabel } from './utils';

export default function FilterChip({ filter, onRemove, filterTypes, filterValues }) {
  const displayValue = getFilterValueLabel(filter.value, filter.type, filterValues);
  const typeLabel = getFilterTypeLabel(filter.type, filterTypes);

  return (
    <div className={styles['filter-item']}>
      <div className={styles['filter-type']}>{typeLabel}:</div>
      <div className={styles['filter-value']} title={displayValue}>
        {displayValue}
      </div>
      <CloseIcon
        onClick={() => onRemove(filter.id)}
        className={styles['filter-remove']}
      />
    </div>
  );
}
